// @ts-nocheck
import * as types from '../../mutation-types';
import actions from './actions';

const state = {
  formData: {},
  result: '',
  error: '',
  feedbackResult: '',
  feedbackError: '',
  rentFormError: '',
};

const mutations = {
  [types.SET_FORM_DATA](state, data) {
    state.formData = data;
  },
  [types.SET_FORM_RESULT](state, result) {
    state.result = getResultMessage(result);
  },
  [types.SET_FORM_ERROR](state, result) {
    state.error = getErrorMessage(result);
  },
  [types.SET_FEEDBACK_FORM_RESULT](state) {
    state.feedbackResult = 'Viesti lähetetty. Kiitos palautteestasi.';
  },
  [types.SET_FEEDBACK_FORM_ERROR](state, result) {
    state.feedbackError = getErrorMessage(result);
  },
  [types.SET_RENT_FORM_ERROR](state, result) {
    state.rentFormError = result;
  },
};

const getResultMessage = (code) => {
  const MESSAGES = [{ code: 200, message: 'Viesti lähetetty onnistuneesti.' }];

  let result = '';

  MESSAGES.forEach((message) => {
    if (message.code === code) {
      result = message.message;
    }
  });
  return result;
};

const getErrorMessage = (code) => {
  const MESSAGES = [
    { code: 400, message: 'Viestin lähettäminen epäonnistui, tarkista syöttämäsi tiedot.' },
    { code: 500, message: 'Viestin lähettäminen epäonnistui, yritä hetken kuluttua uudelleen.' },
  ];

  let result = '';

  MESSAGES.forEach((message) => {
    if (message.code === code) {
      result = message.message;
    }
  });
  return result;
};

const getters = {
  formData: (state) => state.formData,
  contactFormError: (state) => state.error,
  contactFormResult: (state) => state.result,
  feedbackContactFormError: (state) => state.feedbackError,
  feedbackContactFormResult: (state) => state.feedbackResult,
  rentFormError: (state) => state.rentFormError,
};

export default {
  state,
  getters,
  mutations,
  actions,
};
